import {RouterProvider, createRouter} from '@tanstack/react-router'
import {routeTree} from './routeTree.gen'
import {ColorSchemeScript, MantineProvider} from "@mantine/core";
import {theme} from "./theme.ts";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {DatesProvider} from "@mantine/dates";

const router = createRouter({routeTree})
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import 'dayjs/locale/cs'
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import {Notifications} from "@mantine/notifications";
import {ModalsProvider} from "@mantine/modals";
import {setupSentry} from "./sentry.init.ts";
import {SentryCrashReportModal} from "@components/sentryCrashReportModal.tsx";


// Register the router instance for type safety
declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router
	}
}

const queryClient = new QueryClient()

setupSentry(router)
function App() {

	return (
		<>
			<ColorSchemeScript forceColorScheme={"dark"}/>
			<MantineProvider theme={theme} forceColorScheme={"dark"}>
				<DatesProvider settings={{locale: 'cs', firstDayOfWeek: 1, timezone: "Europe/Prague", consistentWeeks: true}}>
					<QueryClientProvider client={queryClient}>
						<ModalsProvider modals={{
							crashReport: SentryCrashReportModal
						}}>
							<Notifications />
							<RouterProvider router={router}/>
							<ReactQueryDevtools />
						</ModalsProvider>
					</QueryClientProvider>
				</DatesProvider>
			</MantineProvider>
		</>
	)
}

export default App
